import { render, staticRenderFns } from "./submit-success.vue?vue&type=template&id=783ff6e0"
import script from "./submit-success.vue?vue&type=script&lang=js"
export * from "./submit-success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports